var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerplayLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 0.899997L116.3 0.699997C122.9 0.699997 128.3 6.1 128.3 12.7L128.5 116.8C128.5 123.4 123.1 128.8 116.5 128.8L12.4 129C5.80001 129 0.400011 123.6 0.400011 117L0.200012 12.9C0.200012 6.3 5.60001 0.899997 12.2 0.899997Z",
    fill: "#B82025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 54.2L33.1 43.8L67.4 43.7L31.7 110.3L46.9 54L26.4 54.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 94.8L72.6 43.7H100.6L93.2 53.3L73.1 53.1L78.3 66.7L45.6 94.8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7205 40.1C76.5748 40.0888 81.3115 35.3339 81.3003 29.4797C81.289 23.6255 76.5342 18.8888 70.68 18.9C64.8257 18.9112 60.089 23.6661 60.1003 29.5203C60.1115 35.3745 64.8663 40.1112 70.7205 40.1Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerplayLogoIcon);
export default __webpack_public_path__ + "static/media/powerplay-logo-icon.ccb08ae23a1b4ec137f94a969e5bce82.svg";
export { ForwardRef as ReactComponent };